import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Button from './ui/Button';
import LeadFormModal from './LeadFormModal';

const LeadFormButton = ({ 
  children, 
  variant = "default", 
  size = "md",
  className = "",
  iconName = "UserPlus",
  iconPosition = "left",
  ...props 
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchParams] = useSearchParams();

  // Abrir modal se houver parâmetro na URL
  React.useEffect(() => {
    if (searchParams.get('lead-form') === 'open') {
      setIsModalOpen(true);
    }
  }, [searchParams]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        iconName={iconName}
        iconPosition={iconPosition}
        onClick={handleOpenModal}
        {...props}
      >
        {children || 'Solicitar Orçamento'}
      </Button>
      
      <LeadFormModal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal} 
      />
    </>
  );
};

export default LeadFormButton;
